import React from 'react';
import styles from './NotFound.module.scss';
const NotFound = () => {
  return <div class={styles.wrap}>Страница не найдена</div>;
};

export default NotFound;
